// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"10":"9b8826c4","272":"82be54ef","430":"c8d524d2","791":"a88764af"}[chunkId] + ".css";
};